"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var DocumentService = (function () {
    function DocumentService(endpointConfig, context, axiosInstance) {
        this.endpointConfig = endpointConfig;
        this.context = context;
        this.axiosInstance = axiosInstance;
        // use default instance, when no instance is provided.
        this.axiosInstance = this.axiosInstance || axios_1.default;
    }
    DocumentService.prototype.getPreview = function (documentId, isAnonymous) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var endpoint = _this.endpointConfig.getGorillaBoyEndpoint();
            var cfg = {
                isAnonymousCall: isAnonymous,
            };
            _this.axiosInstance
                .get(endpoint + '/gb/api/v1/document/' + documentId + '?exclude=OLD_PERMISSIONS', cfg)
                .then(function (response) {
                var data = response.data;
                if (!data.Document || !data.Document.Metadata || !data.Document.Metadata.VersionMetadata) {
                    reject(response);
                    return;
                }
                var VersionId = data.Document.Metadata.VersionMetadata.VersionId;
                _this.axiosInstance
                    .get(endpoint + '/api/v1/documents/' + documentId + '/versions/' + VersionId + '?exclude=OLD_PERMISSIONS&fields=preview', cfg)
                    .then(function (response) {
                    var data = response.data;
                    if (!data.Metadata || !data.Metadata.Preview) {
                        reject(response);
                    }
                    resolve(data.Metadata.Preview);
                })
                    .catch(function (error) {
                    reject(error.response);
                });
            })
                .catch(function (error) {
                reject(error.response);
            });
        });
    };
    return DocumentService;
}());
exports.default = DocumentService;
